import { Link } from "react-router-dom";
import { Logo } from "@/components/brand/Logo";
import { ThemeToggle } from "@/components/layout/AppShell";
import PlanCards from "@/components/marketing/PlanCards";
import SiteFooter from "@/components/brand/SiteFooter";

export default function Pricing() {
  return (
    <div className="min-h-screen">
      <header className="max-w-6xl mx-auto px-5 h-16 flex items-center"><Logo /><div className="ml-auto flex gap-2 items-center"><ThemeToggle /><Link to="/login" className="text-sm">Entrar</Link></div></header>
      <main className="max-w-6xl mx-auto px-5 py-16">
        <p className="eyebrow mb-3">Planos</p>
        <h1 className="text-4xl sm:text-5xl font-bold mb-3">Escolha seu plano.</h1>
        <p className="text-muted-foreground mb-12">Cancele quando quiser. Cartão recorrente ou Pix mensal via Mercado Pago.</p>
        <PlanCards />
      </main>
      <SiteFooter />
    </div>
  );
}
